import { Method } from "../../data/DataUtils.js";
import * as DataUtils from "../../data/DataUtils.js";
import * as DTOs from "../DTOs/InformacionesDTOs.js";

export const DeleteItem = async (idPadre, idItem) => {
  return await DataUtils.SaveObject(
    Method.DELETE, "informaciones/" + idItem, null
  );
};

export const GetItem = async (idPadre, idItem) => {
  return DataUtils.FetchObject("informaciones/" + idItem);
}

export const GetListaItems = async (pathObjeto, idPadre) => {
  return DataUtils.FetchLista(pathObjeto + "/" + idPadre + "/informaciones");
}

export const PostItem = async (codTipoObjeto, idObjeto, datosItem) => {
  return await DataUtils.SaveObject(
    Method.POST, "informaciones",  DTOs.saveItem(datosItem)
  );
};

export const PutItem = async (codTipoObjeto, idObjeto, datosItem) => {
  return await DataUtils.SaveObject(
    Method.PUT, "informaciones/" + datosItem.id, DTOs.saveItem(datosItem)
  );
};
